import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/**
 * What each subdivision project detail means to an owner. The collector names the
 * page's milestone columns `Milestone · <header>` and the parcel addresses `Address N`.
 */
export const fieldMeanings = declareFieldMeanings({
  sources: ['subdivision'],
  declarations: [
    identity('addresses', 'Project ID', 'Address'),
    administrative('DPW Surveyor'),
    means('detail', 'the project name', ['name', 'Project Name']),
    means('detail', 'the project type', ['type', 'Project Type']),
    means('status', 'the project phase', ['phase', 'Current phase']),
    means('status', 'the project status', ['status', 'Current status']),
    means('date', 'the date the application was received', [
      "Date Rec'd",
      "Milestone · Date Rec'd",
    ]),
    means('date', 'the date sent to City Planning', ['Date to DCP', 'Milestone · Date to DCP']),
    means('date', 'the date received back from City Planning', [
      "Date Rec'd from DCP",
      "Milestone · Date Rec'd from DCP",
    ]),
    means(
      'date',
      'the tentative approval date',
      ['Date DPW Tent. Approval', 'Milestone · Date DPW Tent. Approval'],
      { matters: 'moves the approval the project is waiting for' },
    ),
    means('date', 'the date the mylars were received', [
      "Date Mylars Rec'd",
      "Milestone · Date Mylars Rec'd",
    ]),
    means('date', 'the date the map was recorded', ['Date Recorded', 'Milestone · Date Recorded'], {
      matters: 'marks the subdivision map as recorded, which completes the project',
    }),
    means('detail', 'the activity', ['activity']),
    means('date', 'the activity date', ['date']),
    means('description', "the city's comment on the activity", ['comments'], {
      matters: 'added or changed a note',
      means:
        "This is the city's comment on a project activity. A change means the city added or changed what it says.",
    }),
  ],
});
